<mat-card class="tabs-wrapper card-wrapper mat-card-layout">

</mat-card>